const buildObjectArrayForQuery = (key, values = []) =>
  values.reduce((accum, value, i) => ({...accum, [`${key}[${i}]`]: value}), {});

const buildQueryEntries = (entries = {}, isFilters = false) =>
  Object.entries(entries)
    .filter(([_, v]) => v !== undefined)
    .reduce((accum, [k, v]) => {
      const key = isFilters ? `filter[${k}]` : k;

      if (Array.isArray(v)) {
        return {
          ...accum,
          ...buildObjectArrayForQuery(key, v),
        };
      }

      return {...accum, [key]: v};
    }, {});

const buildUrl = (url, options = {}) => {
  const queryString = new URLSearchParams({
    ...buildQueryEntries(options.filters, true),
    ...buildQueryEntries(options.query),
  }).toString();

  if (queryString.length > 0) {
    return `${url}?${queryString}`;
  }

  return url;
};

export default buildUrl;
